import { useState } from "react";
import { 
  Button,
  Card,
  CardPreview,
  makeStyles,
  Input,
} from "@fluentui/react-components";
import { Dialpad } from "@azure/communication-react";
import { useIsMobile } from "../hooks/useIsMobile";
import { Call16Filled } from "@fluentui/react-icons";

const useStyles = makeStyles({
  card: {
    maxWidth: "480px",
    width: "100%",
    margin: "0 auto",
  },
  header: {
    paddingBottom: "2px",
    //alignItems: "flex-start", //for agent name to appearon top, irrepective of oof msg
  },
  dialpadWrapper: {
    padding: "2.5%",
    width: "95%",
  },
  inputWrapper: {
    marginBottom: "2px",
    width: "96%",
  },
  status: {
    marginTop: "10px",
    padding: "6px 10px",
    backgroundColor: "#F3F2F1",
    borderRadius: "6px",
  },
  error: {
    color: "#b10e1e",
    fontWeight: 600,
    marginTop: "10px",
  },
  footerRow: {
    display: "flex !important",
    justifyContent: "center",
    marginBottom: "45px",
    alignItems: "center",
  },
});

export default function PhonePanel({
  call,
  incomingCall,
  callState,
  onPlaceCall,
}) {
  const styles = useStyles();
  const isMobile = useIsMobile();

  const [dialNumber, setDialNumber] = useState("");

  const isConnected = callState === "Connected";
  const isDisconnected = !call || callState === "Disconnected";
  const hasIncomingCall = incomingCall && !call;

  const handleStartCall = () => {
    if (dialNumber) {
      onPlaceCall(dialNumber);
    }
  };
  /** ----------------------------
   * Format & update E.164 number
   * ---------------------------- */
  const updateDialNumber = (rawValue) => {
    setDialNumber(rawValue);
  };

  return (
    <Card className={styles.card} appearance="filled">
      <CardPreview>
        {!isConnected && (
          <>
            {/* Dialpad */}
            <div className={styles.dialpadWrapper}>
              <Input
                className={styles.inputWrapper}
                id="dialer"
                appearance="underline"
                value={dialNumber}
                onChange={(e, data) => updateDialNumber(data.value)}
                placeholder="Dial a number to start a call"
              />
              <Dialpad
                dialpadMode="dtmf"
                longPressTrigger={isMobile ? "touch" : "mouseAndTouch"}
                onClickDialpadButton={(buttonValue) => {
                  const value = dialNumber || "";
                  const newValue = value + buttonValue;
                  setDialNumber(newValue);
                }}
                styles={{
                  root: {
                    background: "#ffffff",
                  },
                  button: {
                    root: {
                      height: isMobile ? "5rem" : "4rem",
                      width: isMobile ? "6rem" : "5rem",
                      lineHeight: "inherit",
                      background: "#ffffff",
                    },
                    rootHovered: {
                      background: "#e5e7eb",
                      span: {
                        color: "#0f6cbd !important",
                      },
                    },
                    rootPressed: {
                      background: "#d1d5db",
                      color: "#0f6cbd",
                    },
                  },
                  digit: {
                    color: "#0f6cbd",
                    fontWeight: 600,
                  },
                  letter: {
                    color: "#0f6cbd",
                    fontWeight: 600,
                  },
                }}
              />
            </div>


            {/* Call Button / Incoming Call Button */}
            <div className={styles.footerRow}>
              {(
                <Button
                  style={{width:'80%'}}
                  appearance="primary"
                  shape="circular"
                  disabled={!dialNumber || hasIncomingCall}
                  icon={<Call16Filled />}
                  onClick={handleStartCall}
                >
                  Call
                </Button>
              )}
            </div>
          </>
        )}
      </CardPreview>
    </Card>
  );
}
